﻿document.addEventListener("DOMContentLoaded", function() {
  let page = 1
  const loadMoreButton = document.getElementById("load-more-news")
	if (!loadMoreButton) return
  const newsList = document.getElementById("news-list")
  const take = loadMoreButton.getAttribute("data-count") || 10

  loadMoreButton.addEventListener("click", function() {
    page++;
    fetch(`/umbraco/api/news/getmore?page=${page}&take=${take}`)
      .then(response => response.json())
      .then(data => {
        if (data.length > 0) {
          data.forEach(item => {
            const li = document.createElement("li")
            li.innerHTML = `
                <div class="details">
                  <div class="date">
                    ${item.date}
                  </div>
                  <div class="category ${item.category}">
                    ${item.category == "news" ? "Nyhet" : "Ny avtalskund"}
                  </div>
                </div>
                <div class="title">
                  <a href="${item.url}" title="${item.title}">
                    ${item.title}
                  </a>
                </div>
                <div class="text">${item.ingress}</div>
            `;
            newsList.appendChild(li)
          })
        }
        if (data.length < take) {
          loadMoreButton.style.display = "none"
        }
      })
      .catch(error => console.error('Error fetching more news:', error))
  })
})
